import { sleep } from './sleep';

interface RetryOptions<T> {
  doAsync: () => Promise<T>;
  check?: null | ((result: T) => boolean);
  intervalMs?: number;
  retries?: number;
}

export const retry = async <T>({
  doAsync,
  check = null,
  intervalMs = 1000,
  retries = 3,
}: RetryOptions<T>) => {
  let result: T | undefined;
  let error: unknown;
  let attempt = 0;
  let success = false;
  const startTime = Date.now();
  for (let i = 0; i < retries; i++) {
    if (i > 0) {
      await sleep(intervalMs);
    }
    try {
      result = await doAsync();
    } catch (e) {
      error = e;
      continue;
    }
    if (!check || check(result)) {
      attempt = i + 1;
      success = true;
      break;
    }
  }
  const executionTimeMs = Date.now() - startTime;
  return { result, attempt, error, success, executionTimeMs };
};
